@let _time = time();
@let _mergedOptions = mergedOptions();
<span>{{ _time | fluidSecondsToDuration: _mergedOptions }}</span>
